<template>
  <section id="pricing-section" class="pricing-section mb-md-0 mb-4">
    <div class="container">
      <!-- 1. Заголовок -->
      <h2 class="text-center">Инструмент для вашего бизнеса</h2>

      <!-- 2. Описание (На всю ширину, белый текст) -->
      <div class="pricing-intro-block mb-5">
        <p>Infoglobal открывает возможности для автоматизации и масштабирования бизнеса, обеспечивая:</p>
        <ul class="intro-list">
          <li>Увеличение продаж благодаря широкому доступу к новым клиентам и партнёрам.</li>
          <li>
            Автоматизация коммуникаций с перспективой внедрения ИИ ботов, которые будут взаимодействовать с компаниями
            напрямую, экономя время и ресурсы.
          </li>
          <li>
            Оптимизация бизнес-процессов: сокращение необходимости вручную искать клиентов позволит вашим менеджерам
            сосредоточиться на других стратегически важных задачах.
          </li>
          <li>
            Поддержка прозрачности и открытости в деловых отношениях, что укрепляет доверие среди партнёров и клиентов.
            С таким подходом можно значительно повысить эффективность работы и ускорить рост бизнеса. Это действительно
            может стать мощным шагом к большему успеху!
          </li>
        </ul>
      </div>

      <!-- 3. Переключатель (Центрирован) -->
      <template v-if="tariffs['yearly'].length && tariffs['monthly'].length">
        <div class="toggle mb-5">
          <button class="mx-2" :class="{ active: type === 'monthly' }" @click="setType('monthly')">Ежемесячно</button>
          /
          <button class="mx-2" :class="{ active: type === 'yearly' }" @click="setType('yearly')">Ежегодно</button>
        </div>
      </template>

      <!-- 4. СЕТКА ТАРИФОВ (Занимает 100% ширины контейнера) -->
      <div class="tariffs-grid">
        <div v-for="(tariff, index) in tariffs[type]" :key="index" class="pricing-item">
          <template v-if="!isLoading">
            <div class="pricing-item-content">
              <h4 class="mb-3">{{ tariff.name }}</h4>
              <h3 class="mb-3">{{ tariff.price }}₽</h3>
              <div class="divider"></div>

              <div v-if="tariff.description" class="mt-4" v-html="tariff.description"></div>
              <ul v-else class="mt-4">
                <li v-for="feat in getFallbackFeatures(tariff.name)" :key="feat">
                  {{ feat }}
                </li>
              </ul>
            </div>
            <button class="mt-4" @click.prevent="goToPayment(tariff.id)">
              <template v-if="!isPaymentLoading">Подключиться</template>
              <div v-else class="loader my-auto"></div>
            </button>
          </template>
          <div v-else class="loader my-auto"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { defineComponent, ref, computed, onMounted } from 'vue';
  import { tariffsList } from '@/models/main-page';
  import { useStore } from 'vuex';
  import { Modal } from 'bootstrap';

  export default defineComponent({
    name: 'Pricing',
    setup() {
      const isLoading = ref(true);
      const isPaymentLoading = ref(false);
      const store = useStore();
      const loggedIn = computed(() => store.state.auth.status.loggedIn);
      let type = ref('monthly');
      const plans = ref([]);
      const selectedPlans = ref([]);
      const tariffs = ref({
        monthly: [],
        yearly: [],
      });
      const memberships = ref([]);

      const setType = (value) => {
        type.value = value;
      };

      const getPlans = () => {
        tariffs.value['monthly'] = [];
        tariffs.value['yearly'] = [];

        plans.value.forEach((el) => {
          if (el.type === 'monthly') {
            tariffs.value['monthly'].push(el);
          } else if (el.type === 'yearly') {
            tariffs.value['yearly'].push(el);
          }
        });

        // Сортируем по цене, чтобы самый дешевый был слева, дорогой — справа
        tariffs.value['monthly'].sort((a, b) => a.price - b.price);
        tariffs.value['yearly'].sort((a, b) => a.price - b.price);

        isLoading.value = false;
      };

      const getFallbackFeatures = (name) => {
        const list = {
          Масштабирование: ['Обновление данных', 'Связи контрагентов', 'Финансовые показатели'],
          Китай: ['База компаний Китая', 'Проверка лицензий', 'Отчеты на русском'],
          Вместе: ['Все функции РФ', 'Все функции Китая', 'Приоритетная поддержка'],
        };
        return list[name] || ['Доступ к платформе', 'Техническая поддержка'];
      };
      const selectPlan = (name) => {
        selectedPlans.value = [];
        plans.value.forEach((el) => {
          if (el.name.split(' ')[0] === name.split(' ')[0]) {
            selectedPlans.value.push(el);
          }
        });
      };

      const goToPayment = (plan) => {
        isPaymentLoading.value = true;
        if (loggedIn.value) {
          store.dispatch('payments/createOrder', plan).then((res) => {
            window.location.href = res.order_url;
            isPaymentLoading.value = false;
          });
        } else {
          isPaymentLoading.value = false;
          const loginModal = new Modal(document.getElementById('authModal'));
          loginModal.show();
        }
      };

      onMounted(() => {
        if (loggedIn.value) {
          store.dispatch('payments/getMemberships').then((res) => {
            memberships.value = res;
          });
        }

        // Получение списка тарифов
        store.dispatch('payments/getPlans').then((res) => {
          plans.value = res;
          getPlans();
        });
      });
      return {
        type,
        tariffs,
        plans,
        tariffsList,
        selectedPlans,
        isLoading,
        isPaymentLoading,
        setType,
        selectPlan,
        goToPayment,
        getFallbackFeatures,
      };
    },
  });
</script>
